import { Link, NavLink } from "react-router-dom";
import { useEffect, useState } from "react";
import { List, X, Phone } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

const NAV = [
  { to: "/", label: "Accueil" },
  { to: "/services", label: "Services" },
  { to: "/equipe", label: "Équipe" },
  { to: "/actualites", label: "Actualités" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled ? "bg-white border-b border-[#E5E7EB]" : "bg-white/95 backdrop-blur"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2 group">
          <div className="w-9 h-9 bg-[#0D2C54] flex items-center justify-center">
            <span className="text-white font-display font-bold text-lg">M</span>
          </div>
          <div className="leading-tight">
            <div className="font-display font-bold text-[#0D2C54] text-lg tracking-tight">MECA AUTO 17</div>
            <div className="overline text-[#555555] text-[10px]">Tonnay-Charente</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              data-testid={`nav-${item.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors hover:text-[#E63946] ${
                  isActive ? "text-[#E63946]" : "text-[#333333]"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href="tel:+33546887088"
            data-testid="header-phone"
            className="flex items-center gap-2 text-sm text-[#0D2C54] hover:text-[#E63946] font-medium"
          >
            <Phone size={18} weight="bold" /> 05 46 88 70 88
          </a>
          <Link to="/rendez-vous">
            <Button data-testid="header-rdv-btn" className="bg-[#E63946] hover:bg-[#D62839] text-white rounded-none font-semibold tracking-wide px-5 h-10">
              Prendre rendez-vous
            </Button>
          </Link>
        </div>

        <button
          aria-label="Menu"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-btn"
          className="lg:hidden p-2 text-[#0D2C54]"
        >
          {open ? <X size={28} weight="bold" /> : <List size={28} weight="bold" />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden border-t border-[#E5E7EB] bg-white">
          <div className="px-6 py-4 flex flex-col gap-1">
            {NAV.map((i) => (
              <NavLink
                key={i.to}
                to={i.to}
                end={i.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${i.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `py-3 text-base font-medium border-b border-[#E5E7EB] ${
                    isActive ? "text-[#E63946]" : "text-[#333333]"
                  }`
                }
              >
                {i.label}
              </NavLink>
            ))}
            <Link to="/rendez-vous" onClick={() => setOpen(false)} className="mt-3">
              <Button data-testid="mobile-rdv-btn" className="w-full bg-[#E63946] hover:bg-[#D62839] text-white rounded-none h-12 font-semibold">
                Prendre rendez-vous
              </Button>
            </Link>
            <Link to="/devis" onClick={() => setOpen(false)}>
              <Button data-testid="mobile-devis-btn" variant="outline" className="w-full mt-2 rounded-none border-[#0D2C54] text-[#0D2C54] h-12">
                Demander un devis gratuit
              </Button>
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
